import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Spinner from '../../shared/spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { RelatoriosDTO } from '../../shared/dto/relatoriosDTO';
import ArquivoService from '../../services/arquivoService';
import CustomAlert from '../../shared/customAlert';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import RelatorioService from '../../services/relatorioService';
import OriginadorService from '../../services/originadorService';
import PromotoraService from '../../services/promotoraService'; // <--- ADICIONADO
import { Originador } from '../../shared/model/originador';

function OrigensCadastradasComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);

  const [selectedOrigem, setSelectedOrigem] = useState(''); 

  const [tiposOrigemOptions, setTiposOrigemOptions] = useState<string[]>([]);

  // --- ESTADOS DO ORIGINADOR (DUAL LIST BOX) ---
  const [availableOriginadores, setAvailableOriginadores] = useState<Originador[]>([]);
  const [selectedOriginadores, setSelectedOriginadores] = useState<Originador[]>([]);
  const [selectedToMoveOriginadores, setSelectedToMoveOriginadores] = useState<Originador[]>([]);
  const [selectedFromSelectedOriginadores, setSelectedFromSelectedOriginadores] = useState<Originador[]>([]);

  const [availableOrigens, setAvailableOrigens] = useState<any[]>([]);
  const [selectedOrigens, setSelectedOrigens] = useState<any[]>([]);
  const [selectedToMoveOrigens, setSelectedToMoveOrigens] = useState<any[]>([]);
  const [selectedFromSelectedOrigens, setSelectedFromSelectedOrigens] = useState<any[]>([]);

  // Instância dos serviços
  const arquivoService: ArquivoService = new ArquivoService();
  const relatorioService: RelatorioService = new RelatorioService();
  const originadorService: OriginadorService = new OriginadorService();
  const promotoraService: PromotoraService = new PromotoraService(); // <--- ADICIONADO

  const carregarTiposOrigem = async () => {
    setLoading(true);
    try {
      const response = await arquivoService.listarTiposOrigem();
      const listaTipos = response.data;
      setTiposOrigemOptions(listaTipos);

      if (listaTipos && listaTipos.length > 0) {
        let tipoInicial = listaTipos[0];
        if (listaTipos.includes('MATRIZ')) {
            tipoInicial = 'MATRIZ';
        }
        setSelectedOrigem(tipoInicial);
        listarOrigens(tipoInicial);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Erro ao listar tipos de origem", err);
      const fallbackOptions = ['MATRIZ', 'PROMOTORA', 'SUPERVISOR', 'OPERADOR'];
      setTiposOrigemOptions(fallbackOptions);
      setSelectedOrigem('MATRIZ');
      listarOrigens('MATRIZ');
    }
  };

  const listarOrigens = async (origem: string) => {
    setLoading(true);
    try {
      const response = await arquivoService.listarOrigemGenerica(origem);
      setAvailableOrigens(response.data);
      setSelectedOrigens([]);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarOriginadores = async () => {
    setLoading(true);
    try {
        const response = await originadorService.listarTodasOriginadoresPorRole(); 
        setAvailableOriginadores(response.data);
        // setSelectedOriginadores([]); // Comentado para evitar limpar ao recarregar a página sem necessidade
        setLoading(false);
    } catch (err) {
        setLoading(false);
        console.error(err);
    }
  };

  // --- NOVA LÓGICA: FILTRAR PROMOTORAS AO SELECIONAR ORIGINADOR ---
  useEffect(() => {
    const atualizarPromotorasPorOriginador = async () => {
      // Só executa se o tipo selecionado for PROMOTORA
      if (selectedOrigem === 'PROMOTORA') {
        
        // Se tiver originadores selecionados, busca filtrado
        if (selectedOriginadores.length > 0) {
          setLoading(true);
          try {
            const idsOriginadores = selectedOriginadores.map(o => o.id);
            const response = await promotoraService.buscarPorOriginador(idsOriginadores);
            
            // Filtra para não mostrar nas disponíveis as que JÁ estão nas selecionadas
            const novasDisponiveis = response.data.filter((p: any) => 
              !selectedOrigens.some((sel: any) => sel.id === p.id)
            );

            setAvailableOrigens(novasDisponiveis);
          } catch (err) {
            console.error("Erro ao filtrar promotoras por originador", err);
            setAlert({ message: 'Erro ao filtrar promotoras', type: 'error' });
          } finally {
            setLoading(false);
          }
        } else {
          // Se limpar os originadores, volta a listar todas as promotoras (comportamento padrão)
          listarOrigens('PROMOTORA');
        }
      }
    };

    atualizarPromotorasPorOriginador();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOriginadores, selectedOrigem]); 
  // ----------------------------------------------------------------

  const gerarRelatorio = async () => {
    if (selectedOrigens.length <= 0) return setAlert({ message: 'Selecione ao menos uma Origem', type: 'warning' });

    // Validação do Originador
    if (selectedOrigem === 'PROMOTORA' && selectedOriginadores.length <= 0) {
      return setAlert({ message: 'Selecione ao menos um Originador', type: 'warning' });
    }

    setLoading(true);
    try {
      const dto: RelatoriosDTO = new RelatoriosDTO();
      dto.tipoOrigemIds = selectedOrigens.map(origem => origem.id);
      dto.tipoOrigem = selectedOrigem;

      // Enviar IDs do Originador
      if (selectedOrigem === 'PROMOTORA') {
          (dto as any).originadorIds = selectedOriginadores.map(o => o.id);
      }

      const response = await relatorioService.gerarRelatorioOrigensCadastradas(dto);

      const contentType = response.headers['content-type'];

      if (contentType === 'text/plain') {
        const errorText = await response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'Relatorio_Origens_Cadastradas.xlsx');

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      if (err.response && err.response.status === 500 && err.response.data instanceof Blob) {
        const errorText = await err.response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else if (err.response && err.response !== 'AXIOS_TIMEOUT') {
        setAlert({ message: 'Ocorreu um erro ao gerar o relatório', type: 'error' });
      }
      console.error(err);
    }
  };

  useEffect(() => {
    carregarTiposOrigem();
    listarOriginadores(); 
  }, []);

  // --- FUNÇÕES DE MOVIMENTAÇÃO (ORIGEM) ---
  const moveToSelectedOrigens = () => {
    const newSelected = [...selectedOrigens, ...selectedToMoveOrigens];
    const newAvailable = availableOrigens.filter((origem) => !selectedToMoveOrigens.includes(origem));
    setAvailableOrigens(newAvailable);
    setSelectedOrigens(newSelected);
    setSelectedToMoveOrigens([]);
  };

  const moveToAvailableOrigens = () => {
    const newAvailable = [...availableOrigens, ...selectedFromSelectedOrigens];
    const newSelected = selectedOrigens.filter((origem) => !selectedFromSelectedOrigens.includes(origem));
    setAvailableOrigens(newAvailable);
    setSelectedOrigens(newSelected);
    setSelectedFromSelectedOrigens([]);
  };

  const moveAllToSelectedOrigens = () => {
    const newSelected = [...selectedOrigens, ...availableOrigens];
    setSelectedOrigens(newSelected);
    setAvailableOrigens([]);
  };

  const moveAllToAvailableOrigens = () => {
    const newAvailable = [...availableOrigens, ...selectedOrigens];
    setAvailableOrigens(newAvailable);
    setSelectedOrigens([]);
  };

  // --- FUNÇÕES DE MOVIMENTAÇÃO (ORIGINADOR) ---
  const moveToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...selectedToMoveOriginadores];
    const newAvailable = availableOriginadores.filter((o) => !selectedToMoveOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedToMoveOriginadores([]);
  };

  const moveToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedFromSelectedOriginadores];
    const newSelected = selectedOriginadores.filter((o) => !selectedFromSelectedOriginadores.includes(o));
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores(newSelected);
    setSelectedFromSelectedOriginadores([]);
  };

  const moveAllToSelectedOriginadores = () => {
    const newSelected = [...selectedOriginadores, ...availableOriginadores];
    setSelectedOriginadores(newSelected);
    setAvailableOriginadores([]);
  };

  const moveAllToAvailableOriginadores = () => {
    const newAvailable = [...availableOriginadores, ...selectedOriginadores];
    setAvailableOriginadores(newAvailable);
    setSelectedOriginadores([]);
  };
 
  function capitalizeFirstLetter(str: string) {
    if (!str) return '';
    const formatted = str.replace(/_/g, ' ');
    return formatted.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <>
      <div className="position-relative m-md-3">
        {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={()=>setAlert(null)} />)}
        {loading ? <Spinner loading={loading} /> : (
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Relatório de Origens Cadastradas</strong>
            </div>
            <div className="card-body">
              <div className="" style={{ marginTop: '10px' }}>
                <div className="row" style={{ marginTop: '10px' }}>
                  <div className="col-md-3">
                    <label>Tipo da Origem</label>
                    <select 
                      className="form-select" 
                      value={selectedOrigem} 
                      onChange={(e) => {
                        const novoTipo = e.target.value;
                        setSelectedOrigem(novoTipo); 
                        listarOrigens(novoTipo); 

                        // SE MUDAR PARA ALGO QUE NÃO SEJA PROMOTORA, LIMPA A SELEÇÃO DE ORIGINADORES
                        if (novoTipo !== 'PROMOTORA') {
                          setSelectedOriginadores([]);
                          setAvailableOriginadores([]); 
                          listarOriginadores(); // Garante que a lista está pronta para quando voltar
                        }
                      }}
                    >
                      {tiposOrigemOptions.map((tipo) => (
                        <option key={tipo} value={tipo}>
                          {capitalizeFirstLetter(tipo)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* --- DUAL LIST BOX DE ORIGINADORES --- */}
              {selectedOrigem === 'PROMOTORA' && (
                  <div style={{ display: 'flex', marginTop: '10px' }}>
                    <div>
                      <h6>{Originador.DESCRITIVO_GERAL} Disponíveis</h6>
                      <select
                        multiple
                        value={selectedToMoveOriginadores.map((p) => p.id!.toString())}
                        onChange={(e) => {
                          const options = e.target.options;
                          const selected = [];
                          for (let i = 0; i < options.length; i++) {
                            if (options[i].selected) {
                              const item = availableOriginadores.find(p => p.id!.toString() === options[i].value);
                              if (item) selected.push(item);
                            }
                          }
                          setSelectedToMoveOriginadores(selected);
                        }}
                        style={{ width: '575px', height: '180px' }}
                      >
                        {availableOriginadores.map((orig) => (
                          <option key={orig.id} value={orig.id!.toString()}>
                            {orig.id} - {orig.nome!}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <button onClick={moveToSelectedOriginadores} style={{ margin: '5px' }}>{'>'}</button>
                      <button onClick={moveAllToSelectedOriginadores} style={{ margin: '5px' }}>{'>>'}</button>
                      <button onClick={moveToAvailableOriginadores} style={{ margin: '5px' }}>{'<'}</button>
                      <button onClick={moveAllToAvailableOriginadores} style={{ margin: '5px' }}>{'<<'}</button>
                    </div>
                    <div>
                      <h6>{Originador.DESCRITIVO_GERAL} Selecionados</h6>
                      <select
                        multiple
                        value={selectedFromSelectedOriginadores.map((p) => p.id!.toString())}
                        onChange={(e) => {
                          const options = e.target.options;
                          const selected = [];
                          for (let i = 0; i < options.length; i++) {
                            if (options[i].selected) {
                              const item = selectedOriginadores.find(p => p.id!.toString() === options[i].value);
                              if (item) selected.push(item);
                            }
                          }
                          setSelectedFromSelectedOriginadores(selected);
                        }}
                        style={{ width: '575px', height: '180px' }}
                      >
                        {selectedOriginadores.map((orig) => (
                          <option key={orig.id} value={orig.id!.toString()}>
                            {orig.id} - {orig.nome!}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
              )}

              {/* QUADROS ORIGENS */}
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div>
                  <h6>{capitalizeFirstLetter(selectedOrigem.toUpperCase() === 'PROMOTORA' ? 'Promotoras' : selectedOrigem.toUpperCase() === 'PONTOVENDA' || selectedOrigem.toUpperCase() === 'PONTO_VENDA' ? 'Pontos de Venda' : selectedOrigem.toUpperCase()+'es')} Disponíveis</h6>
                  <select
                    multiple
                    value={selectedToMoveOrigens.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const origem = availableOrigens.find(p => p.id!.toString() === options[i].value);
                          if (origem) {
                            selected.push(origem);
                          }
                        }
                      }
                      setSelectedToMoveOrigens(selected);
                    }}
                    style={{ width: '575px', height: '180px' }}
                  >
                    {availableOrigens.map((origem) => (
                      <option key={origem.id} value={origem.id!.toString()}>
                        {origem.id} - {origem.nome!}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <button onClick={moveToSelectedOrigens} style={{ margin: '5px' }}>{'>'}</button>
                  <button onClick={moveAllToSelectedOrigens} style={{ margin: '5px' }}>{'>>'}</button>
                  <button onClick={moveToAvailableOrigens} style={{ margin: '5px' }}>{'<'}</button>
                  <button onClick={moveAllToAvailableOrigens} style={{ margin: '5px' }}>{'<<'}</button>
                </div>
                <div>
                <h6>{capitalizeFirstLetter(selectedOrigem.toUpperCase() === 'PROMOTORA' ? 'Promotoras' : selectedOrigem.toUpperCase() === 'PONTOVENDA' || selectedOrigem.toUpperCase() === 'PONTO_VENDA' ? 'Pontos de Venda' : selectedOrigem.toUpperCase()+'es')} Selecionados</h6>
                  <select
                    multiple
                    value={selectedFromSelectedOrigens.map((p) => p.id!.toString())}
                    onChange={(e) => {
                      const options = e.target.options;
                      const selected = [];
                      for (let i = 0; i < options.length; i++) {
                        if (options[i].selected) {
                          const origem = selectedOrigens.find(p => p.id!.toString() === options[i].value);
                          if (origem) {
                            selected.push(origem);
                          }
                        }
                      }
                      setSelectedFromSelectedOrigens(selected);
                    }}
                    style={{ width: '575px', height: '180px' }}
                  >
                    {selectedOrigens.map((origem) => (
                      <option key={origem.id} value={origem.id!.toString()}>
                        {origem.id} - {origem.nome!}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px', height: '50px', maxWidth: '70%' }}>
                <div className="col-md-3">
                  <button className="input-group-btn" id="App-button-cor-principal"
                    style={{
                      width: '80%', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', border: '1px solid LightGrey', borderRadius: '5px', height: '100%', minWidth: '50px'
                    }} onClick={gerarRelatorio}>
                    <a>
                      <FontAwesomeIcon icon={faPrint} style={{ color: 'White', fontSize: 'larger', marginTop: '5px' }} />
                    </a>
                    <strong style={{ color: 'White', marginLeft: '5px', fontSize: 'larger' }}> Gerar Relatório</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  );
}
export default OrigensCadastradasComponent;